export const environment = {
    production: false,
    appVersion: 'v.1.0.1',
    API_EPLATA_URL: 'https://api.dev.eplata.io/v1',
    eplata_api_key_auth: 'yrNl6czkwLSr8fxXf7kfabpHTwegcZp2YXxZTkd4',
    AUTH_SERVICE_URL: 'https://api.dev.eplata.io/v1/auth-service',
    API_GROUP_URL: 'https://u9fovjk9ac.execute-api.us-east-1.amazonaws.com/dev',
    NG_APP_COGNITO_USER_POOL_ID: '',
    NG_APP_COGNITO_CLIENT_ID: '',
    NG_APP_COGNITO_REDIRECT_SIGN_IN: '',
    NG_APP_COGNITO_REDIRECT_SIGN_OUT: '',
    // organization_id de AURA en este ambiente — mismo valor para TODOS los clientes AURA.
    // Usado para ocultar el flujo de sub-cuentas en clientes que no son AURA (ver
    // client-detail.component.ts isAuraClient): crearAutorizador crea el usuario contra un
    // pool de Cognito fijo, así que para otra organización el alta quedaría rota.
    AURA_ORGANIZATION_ID: '86eb23fa-3f9f-44a2-9bfd-b10251b549a7',
    PORTAL_EMPRESAS_URL: 'https://dev.clientes.aresfintech.mx/auth/register',
    // URL base de los servicios bservices en Fargate (NEXT_PUBLIC_FARGATE_ENVIRONMENT en AdminV1).
    // La usa el módulo Operations (SCR-030 Movimiento unitario) con Bearer accessToken.
    // Pendiente: pedir a backend la URL real de cada ambiente.
    ADMIN_BACK_URL: '',
    FARGATE_URL: '',
    // URL base del servicio de negocio (NEXT_PUBLIC_SERVICIOS_DE_NEGOCIO_URL en AdminV1).
    // La usa Compliance (SCR-017 T6, registros KYC) y la lista de prospectos de prospects-ares (SCR-006 T5).
    // Confirmado por el usuario para prospects-ares/bservices/prospects — dev, ARES (no AURA, que no
    // existe en este código). KYC_REGISTRATIONS de Compliance no está confirmado bajo /bservices, por
    // eso el prefijo /bservices vive en el path (PROSPECT_LIST_EXTERNAL) y no aquí.
    SERVICIOS_NEGOCIO_URL: 'https://api.dev.eplata.io/v1',
    // CLABEs de las cuentas internas de ingresos (SCR-020 Cuentas de ingresos).
    // Corrige KI2 del legacy, donde estaban hardcodeadas en constantes del código.
    // Pendiente: pedir a backend/finanzas las CLABEs reales de cada ambiente.
    FEE_CUSTOMER_CLABE: '',
    VAT_CUSTOMER_CLABE: '',
    OPERATIONS_DASHBOARD_AUTH_URL: 'https://app.powerbi.com/reportEmbed?reportId=fddf418c-eace-499d-a740-9c23a2900b7f&autoAuth=true&ctid=f2b1d770-0315-42e1-8c0c-5f246667ede2',
    awsConfig: {
        aws_project_region: 'us-east-1',
        aws_cloud_logic_custom: [
            {
                name: 'AdminQueries',
                endpoint: 'https://ez2hd1cgil.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'CardUserApi',
                endpoint: 'https://u9fovjk9ac.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataCustomerApi',
                endpoint: 'https://nb2af0jghd.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataDockApi',
                endpoint: 'https://h7dv5nyatd.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataInternalApi',
                endpoint: 'https://6edoacmm18.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataOpmApi',
                endpoint: 'https://czyyiaxil5.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataProspectApi',
                endpoint: 'https://t9h58paqu6.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataPublicApi',
                endpoint: 'https://3twmqg8bqh.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataStatementApi',
                endpoint: 'https://8t0kjwr085.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataStpApi',
                endpoint: 'https://xi16mdby9j.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'EplataTransactionApi',
                endpoint: 'https://natqbd2hne.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'PushNotificationApi',
                endpoint: 'https://lr4hti0ui6.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            },
            {
                name: 'TransactionReceiptApi',
                endpoint: 'https://2d341coyo7.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            }
        ],
        aws_appsync_graphqlEndpoint: 'https://zruazxxav5e35cgkob62mn4coa.appsync-api.us-east-1.amazonaws.com/graphql',
        aws_appsync_region: 'us-east-1',
        aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_apiKey: 'da2-ihe4lvzn2jhlfnupw5scefacoa',
        aws_cognito_identity_pool_id: 'us-east-1:c43d4730-f619-474a-bab5-1af56aed5238',
        aws_cognito_region: 'us-east-1',
        aws_user_pools_id: 'us-east-1_aRkW1jqWY',
        aws_user_pools_web_client_id: '7fv7nsmb87s4on5n92a888oa8p',
        oauth: {},
        aws_cognito_username_attributes: ['EMAIL', 'PHONE_NUMBER'],
        aws_cognito_social_providers: [],
        aws_cognito_signup_attributes: ['EMAIL'],
        aws_cognito_mfa_configuration: 'OFF',
        aws_cognito_mfa_types: ['SMS'],
        aws_cognito_password_protection_settings: {
            passwordPolicyMinLength: 8,
            passwordPolicyCharacters: []
        },
        aws_cognito_verification_mechanisms: ['EMAIL'],
        aws_user_files_s3_bucket: 'tulumuploadsv115ec4-dev',
        aws_user_files_s3_bucket_region: 'us-east-1'
    }
};
